import {orderTemplate} from "../../../app/services/dataTemplates"

export default {

}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/reports/getters.js